import React, { Fragment } from 'react';
import classNames from 'classnames';
import NavMenuItem from '../../NavMenuItem';
import { ProductCrossActivationStatus } from './ProductCrossActivationStatus';
import { ProductTexts } from './ProductTexts';
import { PRODUCT_STATUS } from '../productsStatus';
export var Product = function Product(props) {
  var description = props.description,
      features = props.features,
      id = props.id,
      onLinkClick = props.onLinkClick,
      productStatus = props.productStatus,
      title = props.title,
      url = props.url,
      inverted = props.inverted,
      swicusOrgId = props.swicusOrgId;
  return /*#__PURE__*/React.createElement("div", {
    className: "app-switcher-product"
  }, productStatus === PRODUCT_STATUS.CURRENT_PRODUCT ? /*#__PURE__*/React.createElement("div", {
    "data-qa": "app-switcher-".concat(id),
    className: classNames('cloud-ui-nav-menu-link', 'cloud-ui-nav-menu-current-product')
  }, /*#__PURE__*/React.createElement(ProductContent, {
    swicusOrgId: swicusOrgId,
    title: title,
    description: description,
    productStatus: productStatus,
    features: features,
    inverted: inverted
  })) : /*#__PURE__*/React.createElement(NavMenuItem, {
    "data-qa": "app-switcher-".concat(id),
    href: url,
    newTab: true,
    onClick: onLinkClick
  }, /*#__PURE__*/React.createElement(ProductContent, {
    title: title,
    description: description,
    productStatus: productStatus,
    features: features,
    inverted: inverted,
    swicusOrgId: swicusOrgId
  })));
};

var ProductContent = function ProductContent(_ref) {
  var title = _ref.title,
      description = _ref.description,
      productStatus = _ref.productStatus,
      features = _ref.features,
      inverted = _ref.inverted,
      swicusOrgId = _ref.swicusOrgId;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(ProductTexts, {
    title: title,
    description: description,
    status: productStatus
  }), /*#__PURE__*/React.createElement(ProductCrossActivationStatus, {
    status: productStatus,
    features: features,
    inverted: inverted,
    swicusOrgId: swicusOrgId
  }));
};

export default Product;